module.exports = __webpack_public_path__ + "static/hab_research_6-5f6f5b069998ba01922998df9169777d.png";